const topicItems = [
  { label: '娱乐圈爆料', heat: 980, count: '3.2万帖' },
  { label: '商业内幕', heat: 870, count: '2.8万帖' },
  { label: '网红争议', heat: 760, count: '2.1万帖' },
  { label: '科技泄密', heat: 680, count: '1.9万帖' },
  { label: '综艺黑幕', heat: 590, count: '1.6万帖' },
  { label: '体育八卦', heat: 520, count: '1.4万帖' },
  { label: '政治秘闻', heat: 480, count: '1.2万帖' },
  { label: '社会事件', heat: 440, count: '1.1万帖' },
  { label: '金融暗流', heat: 390, count: '9800帖' },
  { label: '海外爆料', heat: 350, count: '8500帖' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-900">
            话题广场
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            当前最活跃的话题标签，点击进入对应讨论区
          </p>
        </div>

        <div className="flex flex-wrap gap-3">
          {topicItems.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group flex items-center gap-3 px-4 py-3 bg-background-100 border border-background-200/70 rounded-xl hover:border-primary-300/40 transition-all cursor-pointer"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 font-extrabold text-sm shrink-0">
                #{i + 1}
              </span>
              <div>
                <span className="text-sm font-semibold text-foreground-900">{item.label}</span>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-[11px] text-primary-600 font-medium">{item.count}</span>
                  <span className="w-1 h-1 rounded-full bg-background-300" />
                  <div className="flex items-center gap-0.5">
                    <span className="w-10 md:w-12 h-1 rounded-full bg-background-200 overflow-hidden">
                      <span
                        className="block h-full rounded-full bg-accent-500"
                        style={{ width: `${(item.heat / 1000) * 100}%` }}
                      />
                    </span>
                    <span className="text-[10px] text-foreground-500">{item.heat}K</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}